import { Header } from "./header";
import { NavLevelDirective } from "./navLevelDirective";
export * from "./header";
export * from "./navLevelDirective";
export var NAVIGATION_DIRECTIVES = [
    Header,
    NavLevelDirective
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/layout/nav/index.js
// module id = 191
// module chunks = 4